(() => {
  const MERCH_TAG = 'hidden_merch';
  const MESSAGE =
    'Pembelian produk merch ISP tidak bisa digabung dengan pembelian produk COTTONINK.';

  const tagCache = new Map();

  const getCart = () =>
    fetch(`${(window.routes && window.routes.cartUrl) || '/cart'}.js`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then((response) => {
      if (!response.ok) throw response;
      return response.json();
    });

  const productHasMerchTag = (product) =>
    Array.isArray(product?.tags) && product.tags.some((tag) => String(tag) === MERCH_TAG);

  const getHandleFromItem = (item) => {
    if (item.handle) return item.handle;
    if (!item.url) return '';
    const match = String(item.url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const fetchProductIsMerch = (handle) => {
    if (!handle) return Promise.resolve(false);
    if (tagCache.has(handle)) return Promise.resolve(tagCache.get(handle));

    return fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((product) => {
        const isMerch = productHasMerchTag(product);
        tagCache.set(handle, isMerch);
        return isMerch;
      })
      .catch(() => {
        tagCache.set(handle, false);
        return false;
      });
  };

  const getCartMerchState = (cart) => {
    const items = cart?.items || [];
    if (!items.length) {
      return Promise.resolve({ hasMerch: false, hasRegular: false });
    }

    return Promise.all(
      items.map((item) => {
        if (item.properties && (item.properties._hidden_merch === '1' || item.properties._hidden_merch === 1)) {
          return true;
        }
        return fetchProductIsMerch(getHandleFromItem(item));
      })
    ).then((flags) => {
      const hasMerch = flags.some(Boolean);
      const hasRegular = flags.some((flag) => !flag);
      return { hasMerch, hasRegular };
    });
  };

  const assertCanAdd = (addingMerch) =>
    getCart()
      .then(getCartMerchState)
      .then(({ hasMerch, hasRegular }) => {
        const blocked = addingMerch ? hasRegular : hasMerch;
        if (blocked) {
          const error = new Error(MESSAGE);
          error.code = 'MERCH_CART_MIX';
          throw error;
        }
      });

  const showError = (message, anchor) => {
    const text = message || MESSAGE;
    if (anchor && anchor.insertAdjacentElement) {
      const existing = anchor.parentNode && anchor.parentNode.querySelector('.CiMerchCart__Error');
      if (existing) existing.remove();

      const errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'CiMerchCart__Error ProductForm__Error Alert Alert--error';
      errorMessageElement.innerHTML = text;
      anchor.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(() => errorMessageElement.remove(), 4000);
      return;
    }

    window.alert(text);
  };

  const isMerchForm = (form) => {
    if (!form) return false;
    if (form.dataset.hiddenMerch === 'true') return true;
    if (form.classList.contains('ProductForm--hidden-merch')) return true;
    if (form.querySelector('input[name="properties[_hidden_merch]"]')) return true;
    const root = form.closest('[data-hidden-merch]');
    return root ? root.getAttribute('data-hidden-merch') === 'true' : false;
  };

  const initAddToCartGuard = () => {
    if (document.documentElement.dataset.ciMerchCartGuard === 'true') return;
    document.documentElement.dataset.ciMerchCartGuard = 'true';

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-action="add-to-cart"]');
        if (!button || button.dataset.ciMerchChecked === '1') {
          if (button) delete button.dataset.ciMerchChecked;
          return;
        }

        const form = button.closest('form[action*="/cart/add"]');
        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const addingMerch = isMerchForm(form);
        button.setAttribute('disabled', 'disabled');

        assertCanAdd(addingMerch)
          .then(() => {
            button.dataset.ciMerchChecked = '1';
            button.removeAttribute('disabled');
            button.click();
          })
          .catch((error) => {
            button.removeAttribute('disabled');
            showError(error && error.message, button);
          });
      },
      true
    );
  };

  window.CiMerchCart = {
    tag: MERCH_TAG,
    message: MESSAGE,
    productHasMerchTag,
    assertCanAdd,
    showError,
    getCartMerchState,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddToCartGuard);
  } else {
    initAddToCartGuard();
  }
})();
